const ptBR = {
  metaTitle: 'Desenvolvimento Web Profissional | WSJ Soluções Digitais',
  badge: 'Desenvolvimento Web',
  heroTitle: 'Sites profissionais que transformam visitantes em clientes.',
  heroSubtitle:
    'Projetamos e desenvolvemos presença digital de alto padrão — com estratégia, performance e visual que transmite autoridade desde o primeiro clique.',
  heroBadges: [
    'Site institucional',
    'Sistemas web',
    'Landing pages',
    'E-commerce',
    'Performance',
    'SEO',
    'Design premium'
  ],
  btnQuote: 'Solicitar orçamento',
  btnWhatsapp: 'Falar no WhatsApp',
  btnProjects: 'Ver projetos',
  whatsappMessage: 'Olá! Quero solicitar um orçamento para desenvolvimento web com a WSJ.',

  sectionPersuasionTitle: 'Site bonito não basta. Ele precisa vender, carregar rápido e passar confiança.',
  sectionPersuasionLead:
    'Seu site é o vendedor que trabalha 24 horas por dia. Se ele é lento, confuso ou genérico, você perde oportunidades — mesmo com tráfego.',
  persuasionPillars: [
    {
      title: 'Feito para converter',
      desc: 'Estrutura pensada para guiar o visitante até o contato, orçamento ou compra — sem fricção.'
    },
    {
      title: 'Velocidade que impressiona',
      desc: 'Performance otimizada para carregar rápido no celular e no desktop. Google e clientes valorizam isso.'
    },
    {
      title: 'Confiança visual imediata',
      desc: 'Design premium, copy clara e navegação profissional — a marca parece grande desde o primeiro segundo.'
    }
  ],

  sectionWhatTitle: 'O que desenvolvemos',
  sectionWhatLead:
    'Do site institucional que posiciona sua marca ao sistema web que automatiza sua operação — tudo com padrão de produto digital premium.',
  whatWeBuild: [
    { title: 'Site Institucional', desc: 'Presença sólida para empresas que precisam ser levadas a sério online.' },
    { title: 'Landing Pages', desc: 'Páginas de alta conversão para campanhas, lançamentos e captação de leads.' },
    { title: 'E-commerce', desc: 'Lojas digitais com experiência fluida, checkout claro e gestão organizada.' },
    { title: 'Sistemas Web', desc: 'Painéis, fluxos e regras de negócio sob medida para a sua operação.' },
    { title: 'Plataformas SaaS', desc: 'Produtos digitais escaláveis com arquitetura pensada para crescer.' },
    { title: 'Aplicativos Web', desc: 'Experiências avançadas no browser, sem instalação, com UX de app nativo.' },
    { title: 'Portais Empresariais', desc: 'Ambientes corporativos com áreas restritas, perfis e integrações.' },
    { title: 'Automação Empresarial', desc: 'Menos planilha, menos retrabalho — processos digitais que economizam tempo.' }
  ],

  sectionDiffTitle: 'Por que empresas escolhem a WSJ',
  sectionDiffLead:
    'Não entregamos apenas páginas bonitas. Entregamos ativos digitais construídos para gerar resultado, confiança e crescimento.',
  differentials: [
    'Design estratégico — não genérico',
    'Sites rápidos e otimizados',
    'SEO técnico desde a base',
    '100% responsivo (mobile first)',
    'Segurança e boas práticas',
    'Integrações com WhatsApp, CRM e APIs',
    'Arquitetura preparada para escalar',
    'Painéis e CMS quando necessário',
    'Código limpo e documentado',
    'Experiência premium de ponta a ponta'
  ],

  sectionProcessTitle: 'Como funciona o processo',
  sectionProcessLead: 'Transparência em cada etapa — você sabe exatamente o que está sendo construído e quando.',
  processSteps: [
    {
      title: 'Briefing do projeto',
      desc: 'Mapeamos objetivos, público, referências, funcionalidades e prazo realista.'
    },
    {
      title: 'Design e prototipação',
      desc: 'Layout estratégico, identidade visual e fluxo de navegação validados antes do código.'
    },
    {
      title: 'Desenvolvimento profissional',
      desc: 'Implementação com stack moderna, performance, SEO e testes em dispositivos reais.'
    },
    {
      title: 'Publicação e suporte',
      desc: 'Go-live, ajustes finais e orientação para você operar e evoluir com segurança.'
    }
  ],

  sectionTypesTitle: 'Do site institucional ao sistema web',
  sectionTypesLead:
    'São projetos diferentes, com escopos e investimentos diferentes. A WSJ ajuda você a escolher o caminho certo.',
  typesComparisonNote:
    'Site institucional apresenta sua empresa e gera contatos. Sistema web opera regras de negócio — login, painel, banco de dados, APIs e automações — e sempre tem orçamento personalizado conforme a complexidade.',
  typeInstitutionalTitle: 'Site Institucional',
  typeInstitutionalDesc:
    'Para empresas que precisam de presença digital profissional, credibilidade e geração de leads — sem lógica operacional complexa.',
  typeInstitutionalItems: [
    'Página inicial estratégica',
    'Sobre a empresa',
    'Serviços / portfólio',
    'Contato e WhatsApp',
    'SEO estrutural',
    'Layout responsivo',
    'Formulários de conversão'
  ],
  typeInstitutionalPrice: 'A partir de R$ 1.500',
  typeSystemsTitle: 'Sistemas Web / Regras de Negócio',
  typeSystemsDesc:
    'Para operações que exigem login, painéis, banco de dados, fluxos personalizados e automações — cada projeto é único.',
  typeSystemsItems: [
    'Login e autenticação',
    'Painel administrativo',
    'Dashboard e relatórios',
    'Banco de dados',
    'APIs e integrações',
    'Automação de processos',
    'Fluxos operacionais',
    'Controle e permissões'
  ],
  typeSystemsPrice: 'Orçamento personalizado',

  sectionPlansTitle: 'Planos para cada etapa do seu negócio',
  sectionPlansLead:
    'Sites profissionais, suporte contínuo e tecnologia para acelerar sua presença digital.',
  plansBillingMonthly: 'Mensal',
  plansBillingAnnual: 'Anual',
  plansSaveBadge: 'Economize 17%',
  plansCurrencyHint: 'Escolha o plano ideal e ajuste a moeda conforme o seu mercado.',
  plansPerMonth: '/mês',
  plansPerYear: '/ano',
  plansDisclaimer:
    'Todos os planos incluem infraestrutura segura, SSL, hospedagem e suporte técnico básico. Projetos personalizados com regras de negócio, automações, APIs ou sistemas administrativos podem exigir orçamento técnico dedicado.',
  planEssentialName: 'Essential',
  planEssentialDesc: 'Ideal para pequenos negócios que precisam de presença digital profissional.',
  planEssentialFeatures: [
    'Site profissional',
    'Até 5 páginas',
    'Design responsivo',
    'Integração com WhatsApp',
    'SEO básico',
    'Hospedagem inclusa',
    'SSL seguro',
    'Suporte por email',
    'Entrega em 5 a 7 dias'
  ],
  planEssentialCta: 'Começar projeto',
  planGrowthName: 'Growth',
  planGrowthBadge: 'Mais popular',
  planGrowthDesc: 'Ideal para empresas que querem crescer online com estrutura mais profissional.',
  planGrowthFeatures: [
    'Tudo do Essential',
    'Até 15 páginas',
    'SEO avançado',
    'Blog',
    'Performance otimizada',
    'Integrações',
    'Google Maps',
    'Formulários premium',
    'Painel administrativo',
    'Suporte prioritário',
    'Entrega em 7 a 15 dias'
  ],
  planGrowthCta: 'Começar agora',
  planEnterpriseName: 'Enterprise',
  planEnterpriseBadge: 'Premium',
  planEnterpriseDesc: 'Ideal para empresas que precisam de soluções completas, sistemas web e operações personalizadas.',
  planEnterpriseFeatures: [
    'Sistema completo',
    'Páginas ilimitadas',
    'Dashboard avançado',
    'APIs',
    'Automações',
    'Arquitetura personalizada',
    'Escalabilidade',
    'Consultoria técnica',
    'Atendimento dedicado',
    'SLA prioritário',
    'Prazo sob consulta'
  ],
  planEnterpriseCta: 'Falar com especialista',
  plansTrustItems: [
    { title: 'Pagamento seguro', desc: 'Processo claro e protegido do orçamento à entrega.' },
    { title: 'Cancelamento fácil', desc: 'Sem amarras ocultas — transparência em cada etapa.' },
    { title: 'Suporte de verdade', desc: 'Equipe acessível, não robôs nem respostas genéricas.' }
  ],

  sectionTrustTitle: 'Confiança em cada entrega',
  sectionTrustLead: 'Você contrata uma equipe que trata seu projeto como produto — não como template descartável.',
  trustItems: [
    { title: 'Atendimento profissional', desc: 'Comunicação clara, prazos honestos e acompanhamento em cada fase.' },
    { title: 'Código limpo', desc: 'Base técnica organizada, segura e preparada para evoluções futuras.' },
    { title: 'Layout responsivo', desc: 'Perfeito no celular, tablet e desktop — onde seus clientes realmente estão.' },
    { title: 'Entrega organizada', desc: 'Escopo definido, revisões alinhadas e go-live sem surpresas.' },
    { title: 'Suporte pós-entrega', desc: 'Orientação após a publicação para você operar com tranquilidade.' },
    { title: 'Estratégia para conversão', desc: 'Cada seção pensada para transformar visita em contato, lead ou venda.' }
  ],

  sectionPortfolioTitle: 'Projetos que representam nosso padrão',
  sectionPortfolioLead:
    'Referências conceituais do nível visual, técnico e estratégico que aplicamos em cada entrega real.',
  portfolioItems: [
    {
      title: 'Maré Alta Gastronomia',
      category: 'Restaurante Premium',
      desc: 'Site institucional com reservas, cardápio digital e identidade sofisticada.',
      result: 'Conversão +42%',
      tags: ['Institucional', 'Mobile first'],
      gradient: 'from-amber-500/35 to-orange-700/20'
    },
    {
      title: 'Clínica Lumina',
      category: 'Saúde & Estética',
      desc: 'Landing de procedimentos com agendamento e prova social estratégica.',
      result: 'Leads +68%',
      tags: ['Landing', 'SEO local'],
      gradient: 'from-rose-500/30 to-pink-700/15'
    },
    {
      title: 'Barber House 88',
      category: 'Barbearia Moderna',
      desc: 'Presença digital premium com WhatsApp integrado e agendamento rápido.',
      result: 'Agendamentos +55%',
      tags: ['Institucional', 'WhatsApp'],
      gradient: 'from-slate-400/25 to-zinc-700/15'
    },
    {
      title: 'FlowMetrics SaaS',
      category: 'Plataforma SaaS',
      desc: 'Dashboard analítico, autenticação e painel administrativo completo.',
      result: 'Retenção +31%',
      tags: ['Sistema web', 'Dashboard'],
      gradient: 'from-sky-500/30 to-blue-700/20'
    },
    {
      title: 'Rota Express Delivery',
      category: 'Food Tech',
      desc: 'Plataforma de pedidos com fluxo operacional e integração WhatsApp.',
      result: 'Pedidos +89%',
      tags: ['Sistema web', 'Automação'],
      gradient: 'from-emerald-500/28 to-teal-700/15'
    },
    {
      title: 'Advocacia Mendes & Co.',
      category: 'Escritório Empresarial',
      desc: 'Site corporativo com autoridade visual, blog jurídico e captação de clientes.',
      result: 'Consultas +37%',
      tags: ['Corporativo', 'Blog'],
      gradient: 'from-indigo-500/28 to-violet-700/20'
    }
  ],

  sectionRealProjectsTitle: 'Projetos reais desenvolvidos pela WSJ',
  sectionRealProjectsLead: 'Empresas que confiaram na WSJ para construir sua presença digital.',
  realProjectsVisitCta: 'Visitar site',
  realProjectBadgeInstitutional: 'Institucional',
  realProjectBadgeEcommerce: 'E-commerce',
  realProjects: [
    {
      name: 'BENCOAÇO',
      url: 'https://bencoaco.com.br/',
      category: 'Site Institucional',
      badge: 'institutional',
      desc: 'Website institucional moderno desenvolvido para apresentar a empresa, serviços e fortalecer a presença digital.',
      logo: '/assets/clients/bencoaco.png',
      previewGradient: 'from-blue-600/30 via-sky-900/15 to-slate-950/50'
    },
    {
      name: 'SOETO',
      url: 'https://www.soeto.com.br/',
      category: 'E-commerce',
      badge: 'ecommerce',
      desc: 'Loja virtual desenvolvida com foco em experiência do usuário, catálogo de produtos e performance.',
      logo: '/assets/clients/soeto.png',
      previewGradient: 'from-emerald-600/28 via-green-900/15 to-slate-950/50'
    },
    {
      name: 'CAFEGHINI',
      url: 'https://www.cafeghini.com.br/',
      category: 'E-commerce',
      badge: 'ecommerce',
      desc: 'E-commerce moderno com foco em vendas online, navegação intuitiva e identidade visual premium.',
      logo: '/assets/clients/cafeghini.png',
      previewGradient: 'from-rose-600/30 via-red-900/15 to-slate-950/50'
    }
  ],

  sectionTechTitle: 'Tecnologias que sustentam o projeto',
  sectionTechLead: 'Stack moderna, testada e usada por empresas que exigem performance, segurança e escala.',
  technologies: ['React', 'Next.js', 'Node.js', 'Spring Boot', 'PostgreSQL', 'Docker', 'AWS', 'TypeScript', 'Tailwind'],

  sectionFaqTitle: 'Perguntas frequentes',
  sectionFaqLead: 'Transparência total antes de você investir no seu próximo projeto digital.',
  faqItems: [
    {
      q: 'Quanto tempo demora para ficar pronto?',
      a: 'Sites institucionais levam em média 2 a 4 semanas. Sistemas com login, painel e banco de dados dependem do escopo — apresentamos cronograma detalhado no briefing.'
    },
    {
      q: 'Qual a diferença entre site institucional e sistema web?',
      a: 'Site institucional apresenta sua empresa e gera contatos. Sistema web opera processos — login, painéis, dados e automações — e tem orçamento personalizado.'
    },
    {
      q: 'O site fica responsivo no celular?',
      a: 'Sim. Todos os projetos são mobile first — testados em smartphones, tablets e desktops reais.'
    },
    {
      q: 'Vocês oferecem hospedagem e domínio?',
      a: 'Sim. Podemos configurar hospedagem, domínio, SSL e monitoramento — ou integrar à infraestrutura que você já possui.'
    },
    {
      q: 'O site aparece no Google?',
      a: 'Implementamos SEO técnico e estrutural desde a base. Resultados orgânicos também dependem de conteúdo e estratégia contínua.'
    },
    {
      q: 'Posso pedir alterações durante o projeto?',
      a: 'Sim. Cada pacote inclui ciclos de revisão. Alterações fora do escopo são tratadas com transparência antes de executar.'
    }
  ],

  finalCtaTitle: 'Pronto para transformar sua presença digital?',
  finalCtaSubtitle:
    'Solicite um orçamento e receba uma proposta clara — com escopo, prazo e investimento alinhados ao seu objetivo de negócio.',

  heroMock: {
    dashboardLabel: 'Dashboard',
    websiteLabel: 'Website',
    mobileLabel: 'Mobile',
    analyticsLabel: 'Analytics',
    adminLabel: 'Painel Admin',
    saasLabel: 'Plataforma SaaS',
    metric1: 'Conversões',
    metric2: 'Visitantes',
    metric3: '+127%',
    live: 'Ao vivo'
  }
};

const ptPT = {
  ...ptBR,
  heroSubtitle:
    'Projetamos e desenvolvemos presença digital de alto padrão — com estratégia, performance e visual que transmite autoridade desde o primeiro clique.',
  sectionPersuasionLead:
    'O seu site é o vendedor que trabalha 24 horas por dia. Se é lento, confuso ou genérico, perde oportunidades — mesmo com tráfego.',
  persuasionPillars: [
    {
      title: 'Feito para converter',
      desc: 'Estrutura pensada para guiar o visitante até ao contacto, orçamento ou compra — sem fricção.'
    },
    {
      title: 'Velocidade que impressiona',
      desc: 'Performance otimizada para carregar rápido no telemóvel e no desktop. Google e clientes valorizam isso.'
    },
    {
      title: 'Confiança visual imediata',
      desc: 'Design premium, copy clara e navegação profissional — a marca parece grande desde o primeiro segundo.'
    }
  ],
  typeInstitutionalItems: [
    'Página inicial estratégica',
    'Sobre a empresa',
    'Serviços / portefólio',
    'Contacto e WhatsApp',
    'SEO estrutural',
    'Layout responsivo',
    'Formulários de conversão'
  ],
  planEssentialFeatures: [
    'Site profissional',
    'Até 5 páginas',
    'Design responsivo',
    'Integração com WhatsApp',
    'SEO básico',
    'Alojamento incluso',
    'SSL seguro',
    'Suporte por email',
    'Entrega em 5 a 7 dias'
  ],
  planEssentialDesc: 'Ideal para pequenos negócios que precisam de presença digital profissional.',
  planGrowthDesc: 'Ideal para empresas que querem crescer online com estrutura mais profissional.',
  planEnterpriseDesc: 'Ideal para empresas que precisam de soluções completas, sistemas web e operações personalizadas.',
  plansDisclaimer:
    'Todos os planos incluem infraestrutura segura, SSL, alojamento e suporte técnico básico. Projetos personalizados com regras de negócio, automações, APIs ou sistemas administrativos podem exigir orçamento técnico dedicado.',
  planGrowthFeatures: [
    'Tudo do Essential',
    'Até 15 páginas',
    'SEO avançado',
    'Blog',
    'Performance otimizada',
    'Integrações',
    'Google Maps',
    'Formulários premium',
    'Painel administrativo',
    'Suporte prioritário',
    'Entrega em 7 a 15 dias'
  ],
  plansTrustItems: [
    { title: 'Pagamento seguro', desc: 'Processo claro e protegido do orçamento à entrega.' },
    { title: 'Cancelamento fácil', desc: 'Sem amarras ocultas — transparência em cada etapa.' },
    { title: 'Suporte de verdade', desc: 'Equipa acessível, não robôs nem respostas genéricas.' }
  ],
  realProjects: [
    {
      name: 'BENCOAÇO',
      url: 'https://bencoaco.com.br/',
      category: 'Site Institucional',
      badge: 'institutional',
      desc: 'Website institucional moderno desenvolvido para apresentar a empresa, serviços e reforçar a presença digital.',
      logo: '/assets/clients/bencoaco.png',
      previewGradient: 'from-blue-600/30 via-sky-900/15 to-slate-950/50'
    },
    {
      name: 'SOETO',
      url: 'https://www.soeto.com.br/',
      category: 'E-commerce',
      badge: 'ecommerce',
      desc: 'Loja virtual desenvolvida com foco na experiência do utilizador, catálogo de produtos e performance.',
      logo: '/assets/clients/soeto.png',
      previewGradient: 'from-emerald-600/28 via-green-900/15 to-slate-950/50'
    },
    {
      name: 'CAFEGHINI',
      url: 'https://www.cafeghini.com.br/',
      category: 'E-commerce',
      badge: 'ecommerce',
      desc: 'E-commerce moderno com foco em vendas online, navegação intuitiva e identidade visual premium.',
      logo: '/assets/clients/cafeghini.png',
      previewGradient: 'from-rose-600/30 via-red-900/15 to-slate-950/50'
    }
  ],
  finalCtaSubtitle:
    'Solicite um orçamento e receba uma proposta clara — com âmbito, prazo e investimento alinhados ao seu objetivo de negócio.'
};

const enUS = {
  metaTitle: 'Professional Web Development | WSJ Soluções Digitais',
  badge: 'Web Development',
  heroTitle: 'Professional websites that turn visitors into customers.',
  heroSubtitle:
    'We design and build high-end digital presence — with strategy, performance and visuals that signal authority from the first click.',
  heroBadges: [
    'Corporate website',
    'Web systems',
    'Landing pages',
    'E-commerce',
    'Performance',
    'SEO',
    'Premium design'
  ],
  btnQuote: 'Request a quote',
  btnWhatsapp: 'Talk on WhatsApp',
  btnProjects: 'View projects',
  whatsappMessage: 'Hello! I would like a quote for web development with WSJ.',

  sectionPersuasionTitle: 'A pretty site is not enough. It must sell, load fast and build trust.',
  sectionPersuasionLead:
    'Your website is the salesperson that works 24/7. If it is slow, confusing or generic, you lose opportunities — even with traffic.',
  persuasionPillars: [
    { title: 'Built to convert', desc: 'Structure designed to guide visitors to contact, quote or purchase — without friction.' },
    { title: 'Speed that impresses', desc: 'Optimised performance on mobile and desktop. Google and customers both reward it.' },
    { title: 'Instant visual trust', desc: 'Premium design, clear copy and professional navigation — your brand feels established immediately.' }
  ],

  sectionWhatTitle: 'What we build',
  sectionWhatLead: 'From corporate sites that position your brand to web systems that automate operations — all at premium digital product standard.',
  whatWeBuild: [
    { title: 'Corporate Website', desc: 'Solid presence for businesses that need to be taken seriously online.' },
    { title: 'Landing Pages', desc: 'High-conversion pages for campaigns, launches and lead generation.' },
    { title: 'E-commerce', desc: 'Digital stores with smooth experience, clear checkout and organised management.' },
    { title: 'Web Systems', desc: 'Dashboards, workflows and business rules tailored to your operation.' },
    { title: 'SaaS Platforms', desc: 'Scalable digital products with architecture built to grow.' },
    { title: 'Web Applications', desc: 'Advanced browser experiences with native-app UX — no install required.' },
    { title: 'Enterprise Portals', desc: 'Corporate environments with restricted areas, roles and integrations.' },
    { title: 'Business Automation', desc: 'Less spreadsheet, less rework — digital processes that save time.' }
  ],

  sectionDiffTitle: 'Why companies choose WSJ',
  sectionDiffLead: 'We do not deliver pretty pages only. We deliver digital assets built for results, trust and growth.',
  differentials: [
    'Strategic design — not generic templates',
    'Fast optimised sites',
    'Technical SEO from day one',
    '100% responsive (mobile first)',
    'Security and best practices',
    'WhatsApp, CRM and API integrations',
    'Architecture ready to scale',
    'Admin panels and CMS when needed',
    'Clean documented code',
    'Premium end-to-end experience'
  ],

  sectionProcessTitle: 'How the process works',
  sectionProcessLead: 'Transparency at every step — you know exactly what is being built and when.',
  processSteps: [
    { title: 'Project briefing', desc: 'We map goals, audience, references, features and a realistic timeline.' },
    { title: 'Design & prototyping', desc: 'Strategic layout, visual identity and navigation validated before code.' },
    { title: 'Professional development', desc: 'Modern stack, performance, SEO and testing on real devices.' },
    { title: 'Launch & support', desc: 'Go-live, final tweaks and guidance to operate and evolve safely.' }
  ],

  sectionTypesTitle: 'From corporate site to web system',
  sectionTypesLead: 'Different projects, different scopes and investments. WSJ helps you choose the right path.',
  typesComparisonNote:
    'A corporate site presents your company and generates leads. A web system runs business logic — login, panels, databases, APIs and automation — always with a custom quote based on complexity.',
  typeInstitutionalTitle: 'Corporate Website',
  typeInstitutionalDesc: 'For businesses that need professional presence, credibility and lead generation — without complex operational logic.',
  typeInstitutionalItems: ['Strategic home page', 'About', 'Services / portfolio', 'Contact & WhatsApp', 'Structural SEO', 'Responsive layout', 'Conversion forms'],
  typeInstitutionalPrice: 'From $299',
  typeSystemsTitle: 'Web Systems / Business Logic',
  typeSystemsDesc: 'For operations requiring login, panels, databases, custom workflows and automation — every project is unique.',
  typeSystemsItems: ['Login & authentication', 'Admin dashboard', 'Dashboard & reports', 'Database', 'APIs & integrations', 'Process automation', 'Operational workflows', 'Access control'],
  typeSystemsPrice: 'Custom quote',

  sectionPlansTitle: 'Plans for every stage of your business',
  sectionPlansLead:
    'Professional websites, ongoing support and technology to accelerate your digital presence.',
  plansBillingMonthly: 'Monthly',
  plansBillingAnnual: 'Annual',
  plansSaveBadge: 'Save 17%',
  plansCurrencyHint: 'Pick the right plan and adjust currency for your market.',
  plansPerMonth: '/mo',
  plansPerYear: '/yr',
  plansDisclaimer:
    'All plans include secure infrastructure, SSL, hosting and basic technical support. Custom projects with business rules, automations, APIs or admin systems may require a dedicated technical quote.',
  planEssentialName: 'Essential',
  planEssentialDesc: 'Ideal for small businesses that need a professional digital presence.',
  planEssentialFeatures: [
    'Professional website',
    'Up to 5 pages',
    'Responsive design',
    'WhatsApp integration',
    'Basic SEO',
    'Hosting included',
    'Secure SSL',
    'Email support',
    'Delivery in 5–7 days'
  ],
  planEssentialCta: 'Start project',
  planGrowthName: 'Growth',
  planGrowthBadge: 'Most popular',
  planGrowthDesc: 'Ideal for companies that want to grow online with a more professional structure.',
  planGrowthFeatures: [
    'Everything in Essential',
    'Up to 15 pages',
    'Advanced SEO',
    'Blog',
    'Optimised performance',
    'Integrations',
    'Google Maps',
    'Premium forms',
    'Admin dashboard',
    'Priority support',
    'Delivery in 7–15 days'
  ],
  planGrowthCta: 'Get started',
  planEnterpriseName: 'Enterprise',
  planEnterpriseBadge: 'Premium',
  planEnterpriseDesc: 'Ideal for businesses that need complete solutions, web systems and tailored operations.',
  planEnterpriseFeatures: [
    'Full system',
    'Unlimited pages',
    'Advanced dashboard',
    'APIs',
    'Automations',
    'Custom architecture',
    'Scalability',
    'Technical consulting',
    'Dedicated account manager',
    'Priority SLA',
    'Timeline on consultation'
  ],
  planEnterpriseCta: 'Talk to a specialist',
  plansTrustItems: [
    { title: 'Secure payment', desc: 'Clear, protected process from quote to delivery.' },
    { title: 'Easy cancellation', desc: 'No hidden lock-in — transparency at every step.' },
    { title: 'Real support', desc: 'Accessible team — not bots or generic replies.' }
  ],

  sectionTrustTitle: 'Trust in every delivery',
  sectionTrustLead: 'You hire a team that treats your project as a product — not a disposable template.',
  trustItems: [
    { title: 'Professional service', desc: 'Clear communication, honest timelines and follow-up at every phase.' },
    { title: 'Clean code', desc: 'Organised, secure technical foundation ready for future evolution.' },
    { title: 'Responsive layout', desc: 'Perfect on phone, tablet and desktop — where your customers actually are.' },
    { title: 'Organised delivery', desc: 'Defined scope, aligned reviews and go-live without surprises.' },
    { title: 'Post-launch support', desc: 'Guidance after publication so you operate with confidence.' },
    { title: 'Conversion strategy', desc: 'Every section designed to turn visits into contact, leads or sales.' }
  ],

  sectionPortfolioTitle: 'Projects that represent our standard',
  sectionPortfolioLead: 'Concept references of the visual, technical and strategic level we apply to every real delivery.',
  portfolioItems: [
    { title: 'Maré Alta Gastronomia', category: 'Premium Restaurant', desc: 'Corporate site with reservations, digital menu and sophisticated identity.', result: 'Conversion +42%', tags: ['Corporate', 'Mobile first'], gradient: 'from-amber-500/35 to-orange-700/20' },
    { title: 'Clínica Lumina', category: 'Health & Aesthetics', desc: 'Procedure landing with booking and strategic social proof.', result: 'Leads +68%', tags: ['Landing', 'Local SEO'], gradient: 'from-rose-500/30 to-pink-700/15' },
    { title: 'Barber House 88', category: 'Modern Barbershop', desc: 'Premium digital presence with WhatsApp and fast booking.', result: 'Bookings +55%', tags: ['Corporate', 'WhatsApp'], gradient: 'from-slate-400/25 to-zinc-700/15' },
    { title: 'FlowMetrics SaaS', category: 'SaaS Platform', desc: 'Analytics dashboard, authentication and full admin panel.', result: 'Retention +31%', tags: ['Web system', 'Dashboard'], gradient: 'from-sky-500/30 to-blue-700/20' },
    { title: 'Rota Express Delivery', category: 'Food Tech', desc: 'Ordering platform with operational flow and WhatsApp integration.', result: 'Orders +89%', tags: ['Web system', 'Automation'], gradient: 'from-emerald-500/28 to-teal-700/15' },
    { title: 'Mendes & Co. Law', category: 'Corporate Office', desc: 'Corporate site with authority visuals, legal blog and client acquisition.', result: 'Consultations +37%', tags: ['Corporate', 'Blog'], gradient: 'from-indigo-500/28 to-violet-700/20' }
  ],

  sectionRealProjectsTitle: 'Real projects built by WSJ',
  sectionRealProjectsLead: 'Companies that trusted WSJ to build their digital presence.',
  realProjectsVisitCta: 'Visit website',
  realProjectBadgeInstitutional: 'Corporate',
  realProjectBadgeEcommerce: 'E-commerce',
  realProjects: [
    {
      name: 'BENCOAÇO',
      url: 'https://bencoaco.com.br/',
      category: 'Corporate Website',
      badge: 'institutional',
      desc: 'Modern corporate website built to showcase the company, its services and strengthen digital presence.',
      logo: '/assets/clients/bencoaco.png',
      previewGradient: 'from-blue-600/30 via-sky-900/15 to-slate-950/50'
    },
    {
      name: 'SOETO',
      url: 'https://www.soeto.com.br/',
      category: 'E-commerce',
      badge: 'ecommerce',
      desc: 'Online store focused on user experience, product catalogue and performance.',
      logo: '/assets/clients/soeto.png',
      previewGradient: 'from-emerald-600/28 via-green-900/15 to-slate-950/50'
    },
    {
      name: 'CAFEGHINI',
      url: 'https://www.cafeghini.com.br/',
      category: 'E-commerce',
      badge: 'ecommerce',
      desc: 'Modern e-commerce focused on online sales, intuitive navigation and premium visual identity.',
      logo: '/assets/clients/cafeghini.png',
      previewGradient: 'from-rose-600/30 via-red-900/15 to-slate-950/50'
    }
  ],

  sectionTechTitle: 'Technologies behind the project',
  sectionTechLead: 'Modern, proven stack used by companies that demand performance, security and scale.',
  technologies: ['React', 'Next.js', 'Node.js', 'Spring Boot', 'PostgreSQL', 'Docker', 'AWS', 'TypeScript', 'Tailwind'],

  sectionFaqTitle: 'FAQ',
  sectionFaqLead: 'Full transparency before you invest in your next digital project.',
  faqItems: [
    { q: 'How long until it is ready?', a: 'Corporate sites typically take 2–4 weeks. Systems with login, panels and databases depend on scope — we provide a detailed timeline in briefing.' },
    { q: 'What is the difference between a corporate site and a web system?', a: 'A corporate site presents your company and generates leads. A web system runs processes — login, panels, data and automation — with a custom quote.' },
    { q: 'Will the site work on mobile?', a: 'Yes. Every project is mobile first — tested on real phones, tablets and desktops.' },
    { q: 'Do you offer hosting and domain?', a: 'Yes. We can set up hosting, domain, SSL and monitoring — or integrate with your existing infrastructure.' },
    { q: 'Will the site appear on Google?', a: 'We implement technical and structural SEO from the ground up. Organic results also depend on content and ongoing strategy.' },
    { q: 'Can I request changes during the project?', a: 'Yes. Each package includes review cycles. Out-of-scope changes are handled transparently before execution.' }
  ],

  finalCtaTitle: 'Ready to transform your digital presence?',
  finalCtaSubtitle: 'Request a quote and receive a clear proposal — with scope, timeline and investment aligned to your business goal.',

  heroMock: {
    dashboardLabel: 'Dashboard',
    websiteLabel: 'Website',
    mobileLabel: 'Mobile',
    analyticsLabel: 'Analytics',
    adminLabel: 'Admin Panel',
    saasLabel: 'SaaS Platform',
    metric1: 'Conversions',
    metric2: 'Visitors',
    metric3: '+127%',
    live: 'Live'
  }
};

const fallbackLocales = ['es', 'fr', 'it', 'hi', 'de', 'nl', 'ru', 'ar', 'zh-CN', 'zh-TW'];

export const webDevPageByLang = {
  'pt-BR': ptBR,
  'pt-PT': ptPT,
  en: enUS,
  ...Object.fromEntries(fallbackLocales.map((code) => [code, enUS]))
};
